import React, { useState, useEffect, useRef } from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';



// import "./portfolio.css";

function AtosCert() {
    // States for input and display values
    const [cert, setCert] = useState('EP/NSDC/ATOS/25-26/730');
    const [cand, setCand] = useState('CAN_29169893');
    const [course, setCourse] = useState('Retail Sales Assistant');
    const [issue, setIssue] = useState('30 Oct 2025');
    const [name, setName] = useState('Taniya');
    const [centre, setCentre] = useState('Bharatpur');
    const [fromDate, setFromDate] = useState('01/07/2025');
    const [toDate, setToDate] = useState('04/09/2025');
    const [leftLogo, setLeftLogo] = useState('');
    const [rightLogo, setRightLogo] = useState('');
    const [implogo, setImplogo] = useState('');
    const [techlogo, setTechlogo] = useState('');

    // Refs for the elements to manipulate the DOM directly (if necessary)
    const logoLeftRef = useRef(null);
    const logoRightRef = useRef(null);
    const implogoRef = useRef(null);
    const techlogoRef = useRef(null);
    const sheetRef = useRef(null);

    // Effect to simulate the "seed" function (setting demo values on mount)
    useEffect(() => {
        setCert('EP/NSDC/ATOS/25-26/730');
        setCand('CAN_29169893');
        setCourse('Retail Sales Assistant');
        setIssue('30 Oct 2025');
        setName('Taniya');
        setCentre('Bharatpur');
        setFromDate('01/07/2025');
        setToDate('04/09/2025');
    }, []);

    // Apply function to update values
    const apply = () => {
        const updatedCert = cert.trim() || '__________';
        const updatedCand = cand.trim() || '__________';
        const updatedCourse = course.trim() || '__________';
        const updatedIssue = issue.trim() || '__________';
        const updatedName = name.trim() || '__________';
        const updatedCentre = centre.trim() || '__________';
        const updatedFromDate = fromDate.trim() || '__________';
        const updatedToDate = toDate.trim() || '__________';

        // Update text content on the certificate (could be done via refs or state)
        // Replace direct DOM manipulation with React state here

        if (logoLeftRef.current) logoLeftRef.current.src = leftLogo || '';
        if (logoRightRef.current) logoRightRef.current.src = rightLogo || '';
        if (implogoRef.current) implogoRef.current.src = implogo || '';
        if (techlogoRef.current) techlogoRef.current.src = techlogo || '';
    };

    // Handle PDF download
    const handleDownload = async () => {
        const canvas = await html2canvas(sheetRef.current, {
            scale: 3,               // Higher = sharper PDF
            useCORS: true,          // Allow external images
            backgroundColor: '#ffffff',
        });

        const imgData = canvas.toDataURL('image/png');

        const pdf = new jsPDF('l', 'mm', [297, 210]); // A4 landscape in mm (width x height)

        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save('Certificate.pdf');
    };


    return (
        <>

            <div class="controls">
                <h3>Fill certificate details</h3>
                <div class="grid">
                    <label>Certificate No.
                        <input id="f-cert" placeholder="ATOS/2025/00123" />
                    </label>
                    <label>Candidate ID
                        <input id="f-cand" placeholder="EP-TR-0001" />
                    </label>
                    <label>Course Name
                        <input id="f-course" placeholder="Software Developer" />
                    </label>
                    <label>Date of Issue
                        <input id="f-issue" placeholder="30 Oct 2025" />
                    </label>

                    <label>Candidate Name (Mr./Ms.)
                        <input id="f-name" placeholder="Rahul Singh" />
                    </label>
                    <label>Centre Name
                        <input id="f-centre" placeholder="Gurugram" />
                    </label>
                    <label>Programme Start
                        <input id="f-from" placeholder="01 Aug 2025" />
                    </label>
                    <label>Programme End
                        <input id="f-to" placeholder="30 Oct 2025" />
                    </label>

                </div>

                <div class="row-actions">
                    <button class="btn" id="applyBtn">Apply to Preview</button>
                    <button class="btn secondary" onclick="window.print()">Print / Save as PDF</button>
                    <button class="btn" id="downloadBtn">Download PDF</button>

                </div>
            </div>




            <div class="sheet">
                <div class="frame"></div>
                <div class="strip"></div>
                <div class="left-rail"></div>
                <div class="right-strip"></div>
                <div class="bottom-strip"></div>
                <div class="corner-square"></div>
                <div class="corner-square bl"></div>



                <div class="content">
                    <div class="toprow">
                        <div class="logos">
                            <img id="logo-left" class="logo" alt="Left Logo" src="images/atos.png" />
                        </div>
                        <img id="logo-right" class="logo nsdc" alt="Right Logo" src="images/nsdc.png" />
                        <div class="title">
                            <h1>CERTIFICATE OF PROFICIENCY</h1>
                            <div class="subtitle">Skill training provided under the CSR initiative of Atos Prayas Foundation
                            </div>
                        </div>
                    </div>

                    <div class="meta">
                        <div class="cell">
                            <div><span class="label">Certificate No.:</span> <span id="v-cert" class="value">__________</span>
                            </div>
                            <div><span class="label">Candidate ID.:</span> <span id="v-cand" class="value">__________</span>
                            </div>
                        </div>
                        <div class="cell right">
                            <div><span class="label">Course Name:</span> <span id="v-course" class="value"
                                style={{ minWidth: "260px" }}>______________</span></div>
                            <div><span class="label">Date of Issue:</span> <span id="v-issue"
                                class="value">______________</span></div>
                        </div>
                    </div>



                    <div class="body">
                        <div class="certificate-body">
                            <div class="cert-line">
                                <span class="label">This is to certify that Mr./Ms.</span>
                                <span class="dotted-field">
                                    <span id="v-name" class="field-text"
                                        style={{ fontWeight: "900", fontSize: "22px" }}>__________</span>
                                </span>
                            </div>

                            <div class="cert-line">
                                <span class="label">has successfully completed a Certificate Programme in</span>
                                <span class="dotted-field mid">
                                    <span id="v-course2" class="field-text">__________</span>
                                </span>
                                <span class="label">course at the</span>
                                <span class="dotted-field short">
                                    <span id="v-centre" class="field-text">__________</span>
                                </span>
                                <span class="label">center.</span>
                            </div>

                            <div class="cert-line">
                                <span class="label">This programme was conducted from</span>
                                <span class="dotted-field date">
                                    <span id="v-from" class="field-text">__________</span>
                                </span>
                                <span class="label">to</span>
                                <span class="dotted-field date">
                                    <span id="v-to" class="field-text">__________</span>
                                </span>
                                <span class="label">.</span>
                            </div>
                        </div>

                        <div class="signrow">
                            <div class="sign">
                                <img src="https://images.rawpixel.com/image_png_social_landscape/cHJpdmF0ZS9sci9pbWFnZXMvd2Vic2l0ZS8yMDI0LTExL3YxMTcxLWVsZW1lbnQtc2ktMzg5LXAucG5n.png"
                                    alt="Signature 1" class="sig-img" />
                                <div class="sig-title">
                                    <strong>Sanjeev Sharma</strong><br />
                                    <span style={{ fontSize: "10px", color: "#666" }}>CEO, Empower Foundation</span>
                                </div>
                            </div>

                            <div class="sign">
                                <img src="https://images.rawpixel.com/image_png_social_landscape/cHJpdmF0ZS9sci9pbWFnZXMvd2Vic2l0ZS8yMDI0LTExL3YxMTcxLWVsZW1lbnQtc2ktMzg5LXAucG5n.png"
                                    alt="Signature 2" class="sig-img" />
                                <div class="sig-title">
                                    <strong>Mrinal Kant</strong><br />
                                    <span style={{ fontSize: "10px", color: "#666" }}>Director, Empower Foundation</span>
                                </div>
                            </div>
                        </div>

                        <div class="partners">
                            <div class="pcolf">
                                <span class="p-title">Implementing Partner</span>
                                <img id="v-implogo" alt="Implementing" src="images/empowerf.png" />
                            </div>
                            <div class="pcol">
                                <span class="p-title">Technical Partner</span>
                                <div class="tlogos">
                                    <img id="v-techlogo2" alt="Technical Partner 2" src="images/empowerpragati.jpg" />
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            </div>


            <style>{`

                            :root {
                                --bg: #F6F5FA;
                            --ink: #111;
                            --muted: #6b7280;
                            --primary: #F1663A;
                            /* orange border strip */
                            --navy: #0F2A33;
                            /* deep teal outer band */
                            --accent: #938EFA;
                            /* subtle accent */
                            --dotted: #a3a3a3;
        }

                            * {
                                box - sizing: border-box
        }

                            html,
                            body {
                                height: 100%;
                            background: #eee;
                            color: var(--ink)
        }

                            body {
                                margin: 0;
                            font-family: Montserrat, system-ui, Segoe UI, Roboto, Helvetica, Arial
        }

                            /* ===== Page sizing for print (A4 landscape) ===== */
                            .sheet {
                                width: 297mm;
                            /* A4 landscape width */
                            height: 210mm;
                            /* A4 landscape height */
                            margin: 10mm auto;
                            background: white;
                            position: relative;
                            overflow: hidden;
                            box-shadow: 0 10px 30px rgba(0, 0, 0, .15);
        }

                            @media print {
                                @page {
                                size: A4 landscape;
                            margin: 0
            }

                            body {
                                background: white
            }

                            .controls {
                                display: none !important
            }

                            .sheet {
                                margin: 0;
                            box-shadow: none
            }
        }

                            /* ===== Frame & background pattern ===== */
                            /* ===== Frame & background pattern ===== */
                            .frame {
                                position: absolute;
                            /* inset slightly inside the colored borders */
                            top: 18mm;
                            bottom: 18mm;
                            left: 12mm;
                            right: 12mm;

                            background: repeating-linear-gradient(135deg,
                            rgba(0, 0, 0, 0.02) 0 12px,
                            rgba(0, 0, 0, 0.03) 16px 16px);
                            z-index: 0;
            /* behind everything */
        }

                            /* top orange strip */
                            .strip {
                                position: absolute;
                            top: 12mm;
                            left: 18mm;
                            right: 18mm;
                            height: 6mm;
                            background: var(--primary);
                            z-index: 2;
        }

                            /* left navy strip */
                            .left-rail {
                                position: absolute;
                            top: 18mm;
                            bottom: 18mm;
                            left: 12mm;
                            width: 6mm;
                            background: var(--navy);
                            z-index: 2;
        }

                            /* right orange strip */
                            .right-strip {
                                position: absolute;
                            top: 18mm;
                            bottom: 18mm;
                            right: 12mm;
                            width: 6mm;
                            background: var(--primary);
                            z-index: 2;
        }

                            /* bottom navy strip */
                            .bottom-strip {
                                position: absolute;
                            left: 18mm;
                            right: 18mm;
                            bottom: 12mm;
                            height: 6mm;
                            background: var(--navy);
                            z-index: 2;
        }


                            /* tiny top-right square */
                            .corner-square {
                                position: absolute;
                            top: 12mm;
                            right: 12mm;
                            width: 5mm;
                            height: 5mm;
                            background: var(--navy);
        }

                            /* tiny bottom-left square */
                            .corner-square.bl {
                                top: auto;
                            left: 12mm;
                            bottom: 12mm;
                            right: auto;
                            width: 5mm;
                            height: 5mm;
                            background: var(--primary);
        }

                            /* ===== Content grid ===== */
                            .content {
                                position: absolute;
                            inset: 25mm 28mm 26mm 34mm;
                            /* room from borders/rails */
                            display: grid;
                            grid-template-rows: auto auto 1fr auto;
                            gap: 14px;
        }

                            /* Header logos + title */
                            .toprow {
                                display: grid;
                            grid-template-columns: 1fr auto;
                            align-items: center;
        }

                            .logos {
                                display: flex;
                            align-items: center;
                            gap: 16px;
        }

                            .logo {
                                width: auto;
                            height: 70px;
                            object-fit: contain;
                            filter: none;
        }

                            .nsdc {
                                justify - self: end;
                            height: 70px
        }

                            .title {
                                grid - column: 1/3;
                            text-align: center;
                            margin-top: 6px;
        }

                            .title h1 {
                                font - size: 29px;
                            letter-spacing: -0.5px;
                            margin: 0;
                            font-weight: bold;
        }

                            .subtitle {
                                text - align: center;
                            font-size: 14px;
                            color: #333;
                            margin-top: 6px;
                            font-weight: bold;
        }

                            /* meta line (course/date on right, cert/candidate on left) */
                            .meta {
                                display: grid;
                            grid-template-columns: 1fr 1fr;
                            gap: 24px;
                            margin-top: 10px;
                            font-size: 12px;
                            color: #111;
        }

                            .meta .cell {
                                display: flex;
                            flex-direction: column;
                            gap: 8px
        }

                            .right {
                                justify - self: end
        }

                            .label {
                                color: black;
                            font-size: 14px;
                            font-weight: 500;
        }

                            .value {
                                min - width: 240px;
                            border-bottom: 1px dotted var(--dotted);
                            padding-bottom: 3px
        }

                            /* body lines */
                            .body {
                                margin - top: 8px;
                            font-size: 14px;
                            line-height: 1.8;
        }

                            .dline {
                                display: inline-block;
                            min-width: 220px;
                            border-bottom: 1px dotted var(--dotted);
                            padding: 0 4px 3px;
                            margin: 0 4px;
                            white-space: nowrap;
        }

                            /* footer signatures and partners */
                            .footer {
                                align - self: end;
                            margin-top: 8px;
        }

        /* .signrow {
                                display: grid;
                            grid-template-columns: 1fr 1fr;
                            gap: 24px;
                            align-items: end;
                            margin-top: 32px;
        }

                            .sign {
                                text - align: center;
                            padding-top: 40px;
                            position: relative;
        }

                            .sign:before {
                                content: "";
                            position: absolute;
                            left: 10%;
                            right: 10%;
                            top: 0;
                            border-top: 1.5px solid #9ca3af;
        }

                            .sig-title {
                                font - size: 11px;
                            color: #333;
                            margin-top: 6px
        } */


                            .signrow {
                                display: grid;
                            grid-template-columns: 1fr 1fr;
                            gap: 24px;
                            align-items: center;
                            justify-items: center;
                            margin-top: 40px;
                            position: relative;
        }

                            .sign {
                                text - align: center;
                            position: relative;
                            width: 100%;
        }

                            .sign::before {
                                content: "";
                            position: absolute;
                            left: 15%;
                            right: 15%;
                            bottom: 52px;
                            border-top: 1px solid #bbb;
        }

                            .sig-img {
                                height: 45px;
                            width: auto;
                            object-fit: contain;
                            margin-bottom: 6px;
        }

                            .sig-title {
                                font - size: 11px;
                            color: #333;
        }

                            .partners {
                                display: flex;
                            justify-content: space-between;
                            align-items: center;
                            font-size: 12px;
                            color: #222;
                            border-top: 1px solid #bbb;
                            margin-top: 40px;
                            padding-top: 12px;
                            position: relative;
        }

                            .partners::before {
                                content: "";
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            height: 1px;
                            background: #aaa;
        }

                            .pcol {
                                flex: 1;
                            text-align: center;
        }

                            .pcolf {
                                flex: 1;
                            text-align: center;
        }

                            .p-title {
                                display: inline-block;
                            font-weight: 500;
                            position: relative;
                            margin-bottom: 4px;
        }


                            .p-title::before,
                            .p-title::after {
                                content: "";
                            position: absolute;
                            top: 50%;
                            width: 40px;
                            height: 1px;
                            background: #777;
        }

                            .p-title::before {
                                left: -50px;
        }

                            .p-title::after {
                                right: -50px;
        }

                            .pcol img {
                                display: block;
                            margin: 6px auto 0;
                            height: 34px;
                            object-fit: contain;
                            margin-top: 19px;
        }


                            .pcolf img {
                                display: block;
                            margin: 6px auto 0;
                            height: 48px;
                            object-fit: contain;
        }

                            .tlogos {
                                display: flex;
                            justify-content: center;
                            align-items: center;
                            gap: 10px;
        }

                            /* ===== Controls (editor) ===== */
                            .controls {
                                max - width: 1100px;
                            margin: 20px auto;
                            background: #fff;
                            border: 1px solid #e5e7eb;
                            border-radius: 12px;
                            padding: 16px;
                            box-shadow: 0 4px 18px rgba(0, 0, 0, .06)
        }

                            .controls h3 {
                                margin: 0 0 10px 0;
                            font-size: 16px
        }

                            .grid {
                                display: grid;
                            gap: 10px;
                            grid-template-columns: repeat(4, minmax(180px, 1fr));
        }

                            .grid label {
                                font - size: 12px;
                            color: #374151
        }

                            .grid input {
                                width: 100%;
                            padding: 8px 10px;
                            border: 1px solid #d1d5db;
                            border-radius: 8px;
                            font: inherit;
        }

                            .row-actions {
                                display: flex;
                            gap: 10px;
                            margin-top: 12px
        }

                            .btn {
                                background: #111;
                            color: #fff;
                            border: none;
                            padding: 10px 14px;
                            border-radius: 10px;
                            cursor: pointer
        }

                            .btn.secondary {
                                background: #4b5563
        }

                            .muted {
                                color: #6b7280;
                            font-size: 12px;
                            margin-left: auto
        }

                            @media (max-width: 1100px) {
            .grid {
                                grid - template - columns: repeat(2, 1fr);
            }
        }

                            @media (max-width: 640px) {
            .grid {
                                grid - template - columns: 1fr
            }

                            .content {
                                inset: 34mm 18mm 24mm 26mm
            }

                            /* a little more breathing room on small screens */
                            .title h1 {
                                font - size: 26px
            }

                            .subtitle {
                                font - size: 11px
            }

                            .meta {
                                grid - template - columns: 1fr;
            }

                            .right {
                                justify - self: start
            }
        }

                            /* =============================cert css========================== */

                            .certificate-body {
                                font - family: 'Montserrat', sans-serif;
                            font-size: 15px;
                            color: #111;
                            margin-top: 18px;
                            line-height: 2.1;
        }

                            .cert-line {
                                display: flex;
                            flex-wrap: wrap;
                            align-items: baseline;
                            justify-content: flex-start;
                            margin-bottom: 8px;
                            text-align: left;
        }

                            /* Normal sentence text */
                            .label {
                                margin: 0 5px 0 0;
                            white-space: nowrap;
        }

                            /* Full dotted underline */
                            .dotted-field {
                                flex - grow: 1;
                            position: relative;
                            border-bottom: 2.1px dashed #9ca3af !important;
                            border-spacing: 3px;
                            height: 18px;
                            margin: 0 6px;
                            min-width: 150px;
                            vertical-align: middle;
        }

                            /* Shorter dotted fields for dates or centers */
                            .dotted-field.short {
                                min - width: 120px;
        }

                            .dotted-field.mid {
                                min - width: 200px;
        }

                            .dotted-field.date {
                                min - width: 130px;
        }

                            /* The centered field text above the dotted line */
                            .field-text {
                                position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -55%);
                            font-weight: 600;
                            font-style: italic;
                            /* background: #fff; */
                            padding: 0 6px;
                            white-space: nowrap;
                            letter-spacing: 0.2px;
        }

                            /* Subtle print-ready adjustments */
                            @media print {
            .certificate - body {
                                font - size: 14px;
                            line-height: 1.9;
                            color: #000;
            }

                            .dotted-field {
                                border - bottom: 0.5px dotted #555;
            }
        }

                        /* ==============================cert css end==========================  */
                

        `}</style>


        </>

    );
}

export default AtosCert;
